export const PFH_TITLE = 'PFH'

export const PFH_DEFAULT_CURRENCY_ID = 2 // GBP

export const PFH_DICTIONARY = {
  corporate: 'Type of Enquiry',
  transfereeNameOrReference: 'Reference/ PO',
  fileNumberOrReference: 'Reference/ PO',
  fileNumberEmployeeIdOrReference: 'Reference/ PO',
  location: 'Tenants Post Code',
  price: 'Budget',
  employee: 'Tenant',
  guest: 'Tenant',
  officeAddressOrPreferredLocation: 'Tenant’s Post Code',
  enterYourLocationOfPreference: 'Tenant’s Post Code',
  reference: 'Reference/ PO',
  refNumber: 'Reference/ PO',
}
